import { WithdrawalReasonKey } from "../../components/withdrawFromStudy/withdrawFromStudyOptions";
import { ApiResponse, get, post } from "../helpers";
import { WithdrawFromStudyEndPoints } from "./configEndPoints";

export type SubmitWithdrawalRequestBody = {
  dataRetentionChoice: number;
  reasonKey?: WithdrawalReasonKey | null;
};

export type WithdrawalRequestStatusDto = {
  hasExistingRequest: boolean;
  dataRetentionChoice?: number | null;
  isDeleteAllDataOptionEnabled?: boolean;
};

const getWithdrawalStatus = async (): Promise<
  ApiResponse<WithdrawalRequestStatusDto>
> => {
  return get<WithdrawalRequestStatusDto>(
    WithdrawFromStudyEndPoints.GetWithdrawalStatus
  );
};

const submitWithdrawalRequest = async (
  body: SubmitWithdrawalRequestBody
): Promise<ApiResponse<number>> => {
  return post<SubmitWithdrawalRequestBody, number>(
    WithdrawFromStudyEndPoints.SubmitWithdrawalRequest,
    body
  );
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const WithdrawFromStudyApi = {
  getWithdrawalStatus,
  submitWithdrawalRequest,
};

export default WithdrawFromStudyApi;
